
import React, { useState } from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import { removeFromCartEvent } from "../../../utils/GoogleAnalytics";

interface LineItemHeadProps {
  item_image: string;
  title: string;
  product_title?:string;
  subtitle: string;
  price: string;
  variant_title: string;
  temp_cart_id?: number | any;
  cart_id: number | any;
  variant_id: number | any;
  product_type?: string;
  power_type?: number | any;

}

const LineItemHead = ({
  item_image,
  title,
  product_title,
  subtitle,
  price,
  variant_title,
  temp_cart_id,
  cart_id,
  product_type,
  power_type,
}: LineItemHeadProps) => {
  const { removeCartItem, removeGold, getCartData } = useShoppingCart();
  const [isDialogOpen, setIsDialogOpen] = useState(false);


  const dataCart = getCartData;
  const tempCartItems:any = dataCart?.data[0]?.temp_cart_items;

  let cart_item_array:any = [];
  
        // if (tempCartItems && tempCartItems.length > 0) {  
        //     for (var x in tempCartItems) {
    
        //       let power_type = ''
        //       if(tempCartItems[x]?.has_power == 1){
        //         power_type = 'power'
        //       }else{
        //         power_type = 'zero power'
        //       }

        //       if(temp_cart_id == tempCartItems[x]?.id ){
    
        //         cart_item_array.push({
        //           item_name: tempCartItems[x]?.product_title,
        //           item_id: tempCartItems[x]?.id,
        //           index: x,
        //           item_brand: 'Aqualens',
        //           item_category: tempCartItems[x]?.product_type,
        //           item_category2: tempCartItems[x]?.title,
        //           item_category3: tempCartItems[x]?.subtitle,
        //           power_type: power_type,
        //           sph_left_eye_power: tempCartItems[x]?.prescription?.left?.sph,
        //           sph_right_eye_power: tempCartItems[x]?.prescription?.right?.sph,
        //           left_eye_boxes: tempCartItems[x]?.prescription?.left?.boxes,
        //           right_eye_boxes: tempCartItems[x]?.prescription?.right?.boxes,
        //           additional_left_eye_power: tempCartItems[x]?.prescription?.left?.ap,
        //           additional_right_eye_power: tempCartItems[x]?.prescription?.right?.ap,
        //           cyl_left_eye_power: tempCartItems[x].prescription?.left?.cyl,
        //           cyl_right_eye_power: tempCartItems[x].prescription?.right?.cyl,
        //           axis_left_eye: tempCartItems[x]?.prescription?.left?.axis,
        //           axis_right_eye:tempCartItems[x]?.prescription?.right?.axis,
        //           item_list_id: tempCartItems[x]?.temp_cart_id,
        //           item_list_name:tempCartItems[x]?.product_type,
        //           item_variant: tempCartItems[x]?.variant_title,
        //           price: tempCartItems[x]?.price,
        //           quantity: tempCartItems[x]?.quantity
      
        //         });
        //     }
        //   }
        // }


        if (tempCartItems && tempCartItems.length > 0) {
          for (let x = 0; x < tempCartItems.length; x++) {
            const tempCartItem = tempCartItems[x];
            let power_type = '';
            if (tempCartItem?.has_power == 1) {
              power_type = 'power';
            } else {
              power_type = 'zero power';
            }
            const filteredObj: any = {};
            Object.keys(tempCartItem).forEach(key => {
              if (tempCartItem[key] !== undefined) {
                filteredObj[key] = tempCartItem[key];
              }
            });


            let item_variant = '';
            if (tempCartItem?.variant_title == 'Default Title') {
              item_variant = 'Solution';
            } else {
              item_variant = tempCartItem?.variant_title;
            }
      
          if(temp_cart_id == tempCartItems[x]?.id ){

            cart_item_array.push({
              index: x,
              item_brand: 'Aqualens',
              ...(filteredObj.product_title !== undefined && { item_name: filteredObj.product_title }),
              ...(filteredObj.id !== undefined && { item_id: filteredObj.id }),
              ...(filteredObj.category_id !== undefined && { item_category: filteredObj.category_id }),
              ...(filteredObj.title !== undefined && { item_category2: filteredObj.title }),
              ...(filteredObj.subtitle !== undefined && { item_category3: filteredObj.subtitle }),
              ...(power_type !== undefined && { power_type }),
              ...(filteredObj.prescription?.left?.sph !== undefined && { sph_left_eye_power: filteredObj.prescription.left.sph }),
              ...(filteredObj.prescription?.right?.sph !== undefined && { sph_right_eye_power: filteredObj.prescription.right.sph }),
              ...(filteredObj.prescription?.left?.boxes !== undefined && { left_eye_boxes: filteredObj.prescription.left.boxes }),
              ...(filteredObj.prescription?.right?.boxes !== undefined && { right_eye_boxes: filteredObj.prescription.right.boxes }),
              ...(filteredObj.prescription?.left?.ap !== undefined && { additional_left_eye_power: filteredObj.prescription.left.ap }),
              ...(filteredObj.prescription?.right?.ap !== undefined && { additional_right_eye_power: filteredObj.prescription.right.ap }),
              ...(filteredObj.prescription?.left?.cyl !== undefined && { cyl_left_eye_power: filteredObj.prescription.left.cyl }),
              ...(filteredObj.prescription?.right?.cyl !== undefined && { cyl_right_eye_power: filteredObj.prescription.right.cyl }),
              ...(filteredObj.prescription?.left?.axis !== undefined && { axis_left_eye: filteredObj.prescription.left.axis }),
              ...(filteredObj.prescription?.right?.axis !== undefined && { axis_right_eye: filteredObj.prescription.right.axis }),
              ...(filteredObj.category_id !== undefined && { item_list_id: filteredObj.category_id }),
              // ...(filteredObj.variant_title !== undefined && { item_variant: filteredObj.variant_title }),
              ...(item_variant !== undefined && { item_variant }),
              ...(filteredObj.price !== undefined && { price: filteredObj.price }),
              ...(filteredObj.quantity !== undefined && { quantity: filteredObj.quantity }),
              ...(filteredObj.product_type !== undefined && { item_list_name: filteredObj.product_type }),
      
            });
          }
          }
        }


  const removeItemPayload = {
    cart_id: cart_id,
    cart_item_id: temp_cart_id,
  };

  const data = {
    cart_id: cart_id,
  };

  const handleOpenDialog = () => {
    // console.log(removeItemPayload);
    console.log(cart_item_array,'cart_item_array','handleOpenDialog');

    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleConfirm = () => {
    if (product_type === "gold_member") {
      removeGold(data);
      removeFromCartEvent(cart_item_array)
    } else {
      removeCartItem(removeItemPayload);
      removeFromCartEvent(cart_item_array)
    }
    setIsDialogOpen(false);
  };
//   console.log(power_type,product_type,'power type','product type');

  return (
    <div className="lineItemProductsDetails">
      {/* <a href="#"> */}
      <div className="productInfo">
        <div className="productImage">
          <img src={item_image} alt="" />
        </div>
        <div className="productTitle_wrapper">
        { title !==  '' && title !==  null ?  
        <h3 className="productTitle">{title}</h3>  
         : 
          <h3 className="productTitle">{product_title}</h3>
          }
         

          <div className="productSubTitle_variant">
            <span className="productSubTitle">{subtitle} </span>
            {/* {variant_title !== "Default Title" && (
              <>
                <span className="separator"></span>
                <span>{variant_title}</span>
              </>
            )} */}
            { power_type === 1 && product_type !== 'colorLens' &&
              <>
                <span className="separator"></span>
                <span>Power</span>
              </>
            }

            {/* { power_type === 0 && product_type !== 'Solution' &&   product_type !== 'Accessories' &&
                <>
                  <span className="separator"></span>
                  <span>Zero Power</span>
                </>
            } */}
           
          </div>
        </div>
      </div>
      {/* </a> */}
      <div className="productPriceWrapper">
        <button
          onClick={() => handleOpenDialog()}
          type="button"
          className="productPrice"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M14 3.98568C11.78 3.76568 9.54667 3.65234 7.32 3.65234C6 3.65234 4.68 3.71901 3.36 3.85234L2 3.98568"
              stroke="#666666"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.6665 3.31203L5.81317 2.4387C5.91984 1.80536 5.99984 1.33203 7.1265 1.33203H8.87317C9.99984 1.33203 10.0865 1.83203 10.1865 2.44536L10.3332 3.31203"
              stroke="#666666"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5664 6.09375L12.1331 12.8071C12.0598 13.8537 11.9998 14.6671 10.1398 14.6671H5.85977C3.99977 14.6671 3.93977 13.8537 3.86644 12.8071L3.43311 6.09375"
              stroke="#666666"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.88672 11H9.10672"
              stroke="#666666"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.3335 8.33203H9.66683"
              stroke="#666666"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
      {isDialogOpen && (
        <div className="dialogBackdrop">
          <div className="dialog">
            <div className="dialogTextWrapper">
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16" fill="none"><path d="M14 3.98568C11.78 3.76568 9.54667 3.65234 7.32 3.65234C6 3.65234 4.68 3.71901 3.36 3.85234L2 3.98568" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M5.6665 3.31203L5.81317 2.4387C5.91984 1.80536 5.99984 1.33203 7.1265 1.33203H8.87317C9.99984 1.33203 10.0865 1.83203 10.1865 2.44536L10.3332 3.31203" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M12.5664 6.09375L12.1331 12.8071C12.0598 13.8537 11.9998 14.6671 10.1398 14.6671H5.85977C3.99977 14.6671 3.93977 13.8537 3.86644 12.8071L3.43311 6.09375" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M6.88672 11H9.10672" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path><path d="M6.3335 8.33203H9.66683" stroke="#666666" strokeLinecap="round" strokeLinejoin="round"></path></svg> */}
              <div className="productImage">
                <img width="64px" src={item_image} alt="" />
              </div>
              <h2>Remove item from cart?</h2>
              <p>Are you sure you want to remove this item?</p>
            </div>
            <div className="buttonContainer">
              <button className="confirmButton" onClick={() => handleConfirm()}>
                Yes, Remove
              </button>
              <button className="cancelButton" onClick={handleCloseDialog}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LineItemHead;
